( function(){
  'use strict';

  angular.module('eclipseApp.checkout').controller('selfServeModemReceiptCtrl', ['$scope', 'uteEndpoint', '$http', '$stateParams', '$rootScope', '$timeout', function($scope, uteEndpoint, $http, $stateParams, $rootScope, $timeout){

    $scope.modemData = {};
    $scope.modemData.status = $stateParams.status || '';
    $scope.modemData.workOrderNo = $stateParams.workOrderNo || '';
    $scope.modemData.equipmentId = $stateParams.equipmentId || '';
    $scope.modemData.details = $stateParams.details || '';
    $scope.modemData.action = $stateParams.action || '';
    $scope.modemData.returnModemSerial = $stateParams.returnModemSerial || '';
    $scope.modemData.pickUpModemSerial = $stateParams.pickUpModemSerial || '';

    console.log('modemData: ',$scope.modemData);

    $scope.repId = $rootScope.ruiMethods.agent.shortName();
    console.log('repId: ',$scope.repId);

    $scope.storeCode = $rootScope.ruiMethods.agent.storeCode();
    $scope.storeName = $rootScope.ruiMethods.agent.storeName();

    console.log('storeCode: ',$scope.storeCode);

    $scope.storeAddress = $rootScope.ruiMethods.agent.storeAddress();
    console.log('storeAddress: ',$scope.storeAddress);

    this.customerProfile = function() {

      var internetAccount = _.findKey($rootScope.userInfo.accounts, {serviceName:'Internet/TV'});
      var accountNumber;

      if (internetAccount != undefined) {
        accountNumber = $rootScope.userInfo.accounts[internetAccount].accountNumber;
      }
      else {
        accountNumber = $rootScope.userInfo.accounts[0].accountNumber;
      };

      var api = {
        customerProfile: uteEndpoint('v1/viewProfile')
      };
      console.log('In get customer profile');
      $http.post(api.customerProfile, {'accountNumber': accountNumber})
        .success(function(data) {
          var profile = data;
          $scope.firstName = profile.fname;
          $scope.lastName = profile.lname;
          $scope.accountNumber = profile.accounts.accountNo || accountNumber;
          $scope.customerAddress = profile.accounts.billingAddress;

          if (profile.accounts.billingAddress.postalCode.length > 5) {
            $scope.customerAddress.postalCode = profile.accounts.billingAddress.postalCode.substr(0, 3) + ' ' + profile.accounts.billingAddress.postalCode.substr(3);
          }

          //Print receipt on page load
          $timeout(function() {
            $rootScope.ruiMethods.printDiv('printable');
          }, 500);

      }).error(function() {
          $scope.accountNumber = accountNumber;
                  _satellite.setVar( "error", "FHSI | searchCreditCard  failed");
                         _satellite.track("bfa-fhsi-error");
          console.log('In getCustomerProfile error');
      });
    };

    $scope.currentDate = moment().format('ll');
    $scope.currentTime = moment().format('hh:mm:ss A');

    this.customerProfile();
  }]);
})();
